import { render, staticRenderFns } from "./ThreeDCantView.vue?vue&type=template&id=672589c4&scoped=true"
import script from "./ThreeDCantView.vue?vue&type=script&lang=js"
export * from "./ThreeDCantView.vue?vue&type=script&lang=js"
import style0 from "./ThreeDCantView.vue?vue&type=style&index=0&id=672589c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672589c4",
  null
  
)

export default component.exports